import { useQuery } from '@apollo/client'
import { BigNumber } from 'ethers'
import { useEffect, useState } from 'react'
import {
  StrategyHistoryItems,
  STRATEGY_HISTORY_ITEM_QUERY
} from '../../../queries/strategyHistoryItemQuery'
import { ONE } from '../../../constants'
import { PredyClient } from '../../../utils/apollo-client'

export type StrategyHistoryItem = {
  id: string
  strategyId: number
  account: string
  action: string
  strategyAmount: BigNumber
  value: BigNumber
  price: BigNumber
  payoff: BigNumber
  timestamp: number
}

export const NUM_ONE_PAGE_ITEMS = 500

export function useStrategyHistory(
  chainId: number,
  strategyId: number,
  account: string
) {
  const [skip, setSkip] = useState(0)
  const [strategyHistory, setStrategyHistory] = useState<StrategyHistoryItem[]>(
    []
  )

  const { data } = useQuery<StrategyHistoryItems>(STRATEGY_HISTORY_ITEM_QUERY, {
    fetchPolicy: 'cache-first',
    variables: {
      owner: account.toLowerCase(),
      strategyId,
      skip: skip,
      first: NUM_ONE_PAGE_ITEMS
    },
    client: PredyClient[chainId]
  })

  useEffect(() => {
    if (data) {
      const newItems = data.strategyUserHistoryItems.map(entity => {
        const strategyAmount = BigNumber.from(entity.strategyAmount)
        const marginAmount = BigNumber.from(entity.marginAmount)
        const payoff = BigNumber.from(entity.payoff)

        return {
          id: entity.id,
          account: entity.account,
          strategyId: Number(entity.strategyId),
          action: entity.action === 'DEPOSIT' ? 'Buy' : 'Sell',
          strategyAmount,
          value: marginAmount,
          price: marginAmount.mul(ONE).div(strategyAmount),
          payoff,
          timestamp: Number(entity.createdAt)
        }
      })

      setStrategyHistory(history => {
        return history
          .concat(newItems)
          .map(item => Object.assign({}, item))
          .sort((a, b) => b.timestamp - a.timestamp)
          .filter(
            val =>
              val.strategyId === strategyId &&
              val.account === account.toLowerCase()
          )
          .filter(
            (val, ind, self) =>
              ind === self.findIndex(item => item.id === val.id)
          )
      })
    }
  }, [account, data, strategyId])

  return {
    strategyHistory,
    skip,
    setSkip
  }
}
